/**
 * bootprompt.js locale configuration
 * locale : Polish
 * author : Szczepan Cieślik
 */

import { addLocale } from "../bootprompt";

addLocale("pl", {
  OK: "OK",
  CANCEL: "Anuluj",
  CONFIRM: "Potwierdź",
});
